module.exports = __webpack_public_path__ + "static/img/wanted.793d15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wanted.png
// module id = EpJU
// module chunks = 1 3